import { Body1, UIHeading1, Button } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';

export interface IMortgageRateHikeBannerProps {
  onClick?: () => void;
}

export const MortgageRateHikeBanner = ({ onClick }: IMortgageRateHikeBannerProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content-container']}>
        <div className={styles['text-container']}>
          <UIHeading1 color="text-on-bright-default">Семейные квартиры на прежних условиях</UIHeading1>
          <Body1 color="text-on-bright-default">До 1 октября есть время</Body1>
        </div>

        <Button onClick={onClick} theme="inverted">
          Буду знать
        </Button>
      </div>

      <div className={styles['image']} aria-hidden="true" />
    </div>
  );
};
